import React, { useState, useEffect, createRef, forwardRef, useImperativeHandle } from 'react';
import { SSelect } from '@avalara/skylab-sdk/react';

const MultiCompanySelect = forwardRef((props, ref) => {

  const selectRef = createRef();
  const [optionsList, setoptionsList] = useState();

  useEffect(() => {
    setoptionsList(companyOptions);
  }, []);

  useImperativeHandle(ref, () => ({
    reset: () => {
      deselectAll();
    }
  }));

  const onSSelectHandler = (event) => {
    props.selectionHandler(event?.detail?.item);
  };

  const onSDeselectHandler = (event) => {
    props.deselectionHandler(event?.detail?.item);
  };

  const deselectAll = () => {
    selectRef.current.deselectAll();
  }

  const companyOptions = props.companyList?.map((company) => {
    const codeOrId = props.valueCompanyCode ? company.code : company.id.toString();
    return {
      label: `${company.code} - ${company.name}`,
      value: codeOrId,
      selected: props.selectedCompanyIds?.includes(codeOrId)
    };
  });

  return (
    <div data-testid="multi-company-select-control" className={props.className}>
      <SSelect
        ref={selectRef}
        data-testid="skylab-select"
        inputId="company-multi-select"
        name="companies"
        optionsList={props.allCompanyOptions || optionsList || []}
        multiple={true}
        showSelectionCount={props.showSelectionCount}
        disabled={props.disabled}
        onS-deselect={onSDeselectHandler}
        onS-select={onSSelectHandler}
      />
    </div>
  );
});

export default MultiCompanySelect;
